import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "twx-session-timeout-dialog",
  standalone: true,
  imports: [DialogModule, ButtonModule],
  templateUrl: "./session-timeout-dialog.component.html",
  styleUrl: "./session-timeout-dialog.component.scss",
})
export class SessionTimeoutDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() continueScanning = new EventEmitter<void>();
  @Output() endSession = new EventEmitter<void>();

  onContinue(): void {
    this.continueScanning.emit();
  }

  onEnd(): void {
    this.endSession.emit();
  }

  onHide(): void {
    this.visibleChange.emit(false);
  }
}
